<template>
	<div v-if="showCloseIcon" class="menu-button" @click="$emit('toggle-menu')">
		<font-awesome-icon class="close-icon" icon="fal fa-times" size="1x" />
	</div>
	<div v-else class="menu-button" :class="color" @click="$emit('toggle-menu')">
		<div class="menu-icon" />
		<span>{{ $t('menu') }}</span>
	</div>
</template>

<script setup>
defineProps({
	showCloseIcon: { type: Boolean, default: false },
	color: { type: String, default: 'light' },
});
defineEmits(['toggle-menu']);
</script>

<style lang="scss" scoped>
.menu-button {
	background: none;
	padding: 0;
	margin: 0;
	font-size: 20px;
	font-weight: 400;
	height: 48px;
	cursor: pointer;
	text-align: left;
	animation: fade-from-left 0.7s ease;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	font-family: var(--button-font-family);
	text-transform: uppercase;
	display: none;

	span {
		color: var(--nav-color-light);
	}

	.close-icon {
		color: var(--nav-color-dark);
		transition:
			background-color 0.3s ease-in-out,
			opacity 0.3s ease-in-out,
			color 0.3s ease-in-out;

		&:hover {
			color: #fff;
		}
	}

	.menu-icon {
		width: 30px;
		height: 28px;
		border-top: 2px solid var(--nav-color-light);
		border-bottom: 2px solid var(--nav-color-light);
		position: relative;
		margin: 0 22px 0 0;

		&::after {
			content: '';
			display: block;
			width: 30px;
			height: 2px;
			position: absolute;
			top: calc(50% - 1px);
			left: 0;
			right: 0;
			background: var(--nav-color-light);
		}
	}

	&.dark {
		background: none;

		span {
			color: var(--cta-color-hover);
		}

		.menu-icon {
			color: var(--cta-color-hover);
			border-color: var(--cta-color-hover);

			&::after {
				background: var(--cta-color-hover);
			}
		}
	}

	svg {
		font-size: 48px;
	}
}

@media (max-width: 920px) {
	.menu-button {
		z-index: 2;
		display: flex;

		svg {
			font-size: 40px;
		}
	}
}
</style>
